import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const baseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';

const registerUser = createAsyncThunk(
  'user/register',
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${baseUrl}/users/register`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );

      return res.data;

    } catch (err) {
      console.log("🔥 REGISTER ERROR:", err.response?.data);

      // ✅ VERY IMPORTANT: send FULL error object
      return rejectWithValue(
        err.response?.data || {
          message: 'Registration failed',
        }
      );
    }
  }
);

export default registerUser;